module.exports = __webpack_public_path__ + "static/media/dropdown.f8e690bc.svg";